module.exports = __webpack_public_path__ + "img/ticket_star.28702499.svg";